import { RefObject, useEffect } from 'react';
import { useLoginManager } from './LoginManagerContext';

function useFocusOnStepChange(
  ref: RefObject<HTMLElement | null>,
  { select = false }: { select?: boolean } = {}
) {
  const { hasChangedStep } = useLoginManager();

  useEffect(() => {
    if (!hasChangedStep) {
      return;
    }

    ref.current?.focus();
    if (select && ref.current instanceof HTMLInputElement) {
      ref.current.select();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useFocusOnStepChange;
